import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Host,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  Self,
  ViewChild,
} from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { CardView } from "src/app/interfaces/cardview";
import { columnsDef, reference } from "src/app/interfaces/columnsDef";
import { FormConfig } from "src/app/interfaces/formconfig";
import { FormServices } from "src/app/services/form.services";
import { HTTPService } from "src/app/services/http.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { UserConfigServices } from "src/app/services/user-config.services";
import { ObjectUtil } from "src/app/system-utils/utils/ObjectUtil";
import {
  CompactType,
  Draggable,
  GridsterConfig,
  GridsterItem,
  GridsterItemComponent,
  GridsterItemComponentInterface,
  GridType,
  PushDirections,
  Resizable,
} from "angular-gridster2";
import { SnackbarService } from "src/app/services/snackbar.service";
import { ChildrenForm } from "src/app/interfaces/children";
import { Capitalize } from "src/app/system-utils/pipes/capitalize";
import { DialogService } from "src/app/services/dialog.service";
import { Filter } from "src/app/interfaces/filter";
import { CustomTab } from "src/app/interfaces/custom-tab";
import { PromptSaveDialogComponent } from "src/app/system-utils/prompt-save-dialog/prompt-save-dialog.component";
import { TabColumns } from "src/app/interfaces/tabcolumns";
import { ObjectUnsubscribedError, Subject, Subscription } from "rxjs";
import { GridsterOption } from "src/app/interfaces/gridster-options";
import { Preference } from "src/app/interfaces/preference";
import { PermissionServices } from "src/app/services/permission.services";
import { action } from "src/app/interfaces/action";
import { CustomActionParametersComponent } from "../simple-datagrid/custom-action-parameters/custom-action-parameters.component";
import { REGISTRY } from "src/app/interfaces/registry-services";
import { HttpErrorResponse } from "@angular/common/http";
import { CopyFormConfigurationComponent } from "./copy-form-configuration/copy-form-configuration.component";
import { FormulaTSService } from "src/app/services/formula-ts.service";
import { MultiTableConfig } from "../simple-datagrid/simple-datagrid.component";
import { animate, query, stagger, state, style, transition, trigger } from "@angular/animations";
import { DataGridColumns } from "src/app/interfaces/dagrid-columns";
import { flowData } from "src/app/interfaces/flowData";
import { FlowModalComponent } from "../flow-action/flowaction.component";
import { NavService } from "src/app/services/nav.service";
import { StepDataInterface } from "src/app/system-utils/side-panel/side-panel.component";
import { ThemeService } from "src/app/services/theme.service";

export interface tab {
  customName:string, 
  originalName:string,
  entityName?:string,
  active:boolean,
  dynamic:boolean
}

interface Safe extends GridsterConfig {
  draggable: Draggable;
  resizable: Resizable;
  pushDirections: PushDirections;
}

@Component({
    selector: "editform",
    templateUrl: "./editform.component.html",
    styleUrls: ["./editform.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PermissionServices],
    animations: [trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ]),
        trigger('listAnimation', [
            transition('* => *', [
                query(':leave', [
                    stagger(0, [
                        animate('0.1s', style({ opacity: 0 }))
                    ])
                ], { optional: true }),
                query(':enter', [
                    style({ opacity: 0 }),
                    stagger(100, [
                        animate('0.3s', style({ opacity: 1 }))
                    ])
                ], { optional: true })
            ])
        ])
    ],
    standalone: false
})

export class EditFormComponent implements OnInit {
  @Input() parentRow: CardView;
  @Input() entityName: string;
  @Input() entityDesc: string;
  @Input() row: Object;
  @Input() filter: Filter[];
  @Input() userConfig: object;
  @Input() tableInformation: columnsDef[];
  @Input() $$REFERENCES: ChildrenForm[];
  @Input() formViewColumns: number = 3;
  @Input() formGroup: UntypedFormGroup;
  @Input() evento: string;
  @Input()customFields:DataGridColumns[] = [];
  @Input() customFunction: Function;
  @Output() saving: EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter();
  @Input() preference: Preference[] = [];
  @Input() actionList: action[] = [];
  @Input() removeReference: string;
  @Input() forceParentRow: string;
  @Input() canConfig: boolean = false;
  @Input() customComponents:Object[] = [];
  customComponentdata:object;
  tabs:tab[];
  nodata=false;
  floatMenu=false;
  openPopup=false;
  /** índice do passo atual no modo wizard (substitui o ViewChild de MatStepper) */
  wizardStep: number = 0;
  /** spinners NG-ZORRO (substituem os ngx-spinner nomeados) */
  formLoading = false;
  multiTableLoading = false;
  oldInformation: Object;
  savingLayout: Subject<Boolean> = new Subject<Boolean>();
  visibleColumns: TabColumns[] = [];
  nonVisibleColumns: TabColumns[] = [];
  mode:string = 'classic';
  formView: FormConfig[] = [];
  editMode: boolean = false;
  designMode: boolean = false;
  icon: string = "settings";
  /** 68px: os campos NG-ZORRO têm label acima do input (mais altos que os 55px do Material) */
  gridsterHeigthRow = 68;
  disabled: boolean = true;
  hasChild: boolean = false;
  children: ChildrenForm[] = [];
  showFormConfig = false;
  customtab: CustomTab[] = [];
  sub: Subscription;
  options: GridsterConfig;
  customgrid: boolean = false;
  permission: any;
  map: Map<string, any>;
  showMulti: boolean = false;
  dataMultiTable: Object[]=[];
  @Input() dataMultiTableConfig:MultiTableConfig[] = [];  
  sub1:Subscription;  
  expanded:boolean = false;
  expanded_form:boolean = false;
  stepData: StepDataInterface[] = [];
  sizeRight: any;
  sizeLeft: any;

  constructor(
    public navService:NavService,
    private http: HTTPService,
    private fs: FormServices,
    private cd: ChangeDetectorRef,
    private injector: Injector,
    private ucs: UserConfigServices,
    private uas: UserAuthenticationServices,
    private snackBar: SnackbarService,
    private capitalize: Capitalize,
    private dialogServices: DialogService,
    public ThemeService:ThemeService,
    @Self() private ap: PermissionServices,
    private componentFactoryResolver: ComponentFactoryResolver,
    private formulaSevices:FormulaTSService
  ) {
    this.fs.cd = this.cd;
    let options = new GridsterOption().get();
    options.compactType = "compactUp";
    options.gridType = "verticalFixed";
    options.fixedRowHeight = this.gridsterHeigthRow;
    options.outerMarginRight=5;
    options.setGridSize = true;
    
    if( this.tabs == null || this.tabs.length == 0 ){
      this.customtab.push({ desctab: "Geral", editing: false, options: options, active: true, originalName:"Geral" });
    }
    
  }

  ngOnDestroy() {
    this.cd.detach();
    if (this.sub != null) {
      this.sub.unsubscribe();
    }
    if (this.sub1 != null) {
      this.sub1.unsubscribe();
    }
    if (this.savingLayout != null) {
      this.savingLayout.unsubscribe();
    }
  }

  private activeStepsCount(): number {
    return (this.tabs || []).filter(t => t != null && String(t.active) === 'true').length;
  }

  goBack(){
    if ( this.wizardStep > 0 ){
      this.wizardStep--;
      this.changeTab();
    }
  }

  goForward(){
    if ( this.wizardStep < this.activeStepsCount() - 1 ){
      this.wizardStep++;
      this.changeTab();
    }
  }

  changeTab() {
    this.customtab.forEach((x) => {
      try{
        if (x.options != null && x.options.api != null) {
          x.options.api.resize();
        }
      }catch(ex){}
      
    });
  }

  tranformToUserConfig() {
    if (ObjectUtil.isNotEmpty(this.userConfig)) {
      if (ObjectUtil.isNotEmpty(this.userConfig["config"])) {
        this.formView = this.userConfig["config"];
      }
    }
    
    this.tableInformation.forEach((col: columnsDef) => {
      if (this.formView.findIndex((c) => c.name === col.COLUMNNAME) > -1) {
        let userConfCol: FormConfig = this.formView.find(
          (c) => c.name === col.COLUMNNAME
        );
        userConfCol.colspan = col.cols == undefined ? 1 : col.cols;
        userConfCol.rowspan = col.rows == undefined ? 1 : col.rows;
        userConfCol.x = col.x;
        userConfCol.y = col.y;
        userConfCol.visible = col.visible;
        userConfCol.tab = !ObjectUtil.isNotEmpty(col.tab) ? "Geral" : col.tab;
      } else {
        let userConfCol: FormConfig = {
          colspan: col.cols == undefined ? 1 : col.cols,
          rowspan: col.rows == undefined ? 1 : col.rows,
          x: col.x,
          y: col.y,
          name: col.COLUMNNAME,
          visible: col.visible,
          tab: !ObjectUtil.isNotEmpty(col.tab) ? "Geral" : col.tab,
        };

        this.formView.push(userConfCol);
      }
      
      if (ObjectUtil.isNotEmpty(col.tab)) {
        if (
          this.customtab.findIndex((value) => value.desctab == col.tab) == -1
        ) {
          if (col.tab != undefined && col.tab != "Disponivel") {
            let options = new GridsterOption().get();
            options.compactType = "compactUp";
            options.gridType = "verticalFixed";
            options.fixedRowHeight = this.gridsterHeigthRow;
            options.outerMarginRight=5
            options.setGridSize = true;
            this.customtab.push({
              desctab: col.tab,
              editing: false,
              options: options,
              active: true,
              originalName: col.tab
            });
          }
        }
      }
    });
  }

  refresh() {
    return new Promise((resolve, reject) => {
      let conditionOb: Object = {};

      this.tableInformation
        .filter((x) => {
          return x.ISPK === 1;
        })
        .forEach((y) => {
          //conditionOb[y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value; 
          conditionOb['this.'+y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value; //jdbc
          //conditionOb[y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value; //TODO verificar se funciona com campos compostos
        });
      
      let condition = ObjectUtil.transformConditionToString(conditionOb);

      let ob = {
        entityName: this.entityName,
        rows: 1,
        showPresentation: true,
        showRelationshipData: false,
        showRelationship: true,
        fetchSize: 0,
        condition: condition,
      };

      this.http.post(ob, "JsonBrokerServices/find", true).subscribe(
        (x) => {
          let dataRows: any[] = x[this.entityName][0];

          if (dataRows != null) {
            this.row = x[this.entityName][0];
            this.fs.refreshForm(
              this.formGroup,
              this.tableInformation,
              this.row,
              false
            );
          }
          
          this.formLoading = false;
          this.cd.detectChanges();
          resolve(true);
        },
        (error) => {
          this.formLoading = false;
          throw error;
        }
      );
    });
  }

  addTab() {
    this.dialogServices.openGenericDialog(
      PromptSaveDialogComponent,
      {
        mensagem: "Prenchimento do nome da aba é obrigatório.",
        label: "Informar o nome da aba",
      },
      (data) => {
        let options = new GridsterOption().get();
        options.compactType = "compactUp";
        options.gridType = "verticalFixed";
        options.fixedRowHeight = this.gridsterHeigthRow;
        options.outerMarginRight=5;
        options.setGridSize = true;
        this.customtab.push({
          desctab: data["nome"],
          editing: false,
          options: options,
          isFk: false,
          active: true,
          originalName: data["nome"]
        });
        this.tabs = [...this.tabs,{originalName:data['nome'], customName:data['nome'], active:true, dynamic: false}];
        this.cd.markForCheck();
      }
    );
  }

  salvar() {
    
    if ( this.showMulti && this.dataMultiTable.length > 1 ){
      this.dialogServices.errorDialoag = false;
      this.dialogServices.openNewDialog(
        `Serão criados ${this.dataMultiTable.length} anúncios. Deseja continuar?`,
        async () => {
          for ( const multiData of this.dataMultiTable ){
            await this.saveData(multiData);
          }
          this.saving.emit({changing: true, keepOpen: false});
        });
        
    }else{
      this.saveData(null);
    }
  }

  saveData(multiData:object){
    return new Promise((resolve,reject)=>{
      this.formLoading = true;
      if (this.customFunction != null) {
        this.customFunction.call(this, this.formGroup,this.customFields,'saving');
      }

      this.formGroup.updateValueAndValidity();
  
      if ( !this.formGroup.invalid ){
        let ob:Object = this.formGroup.getRawValue();
        
        if ( multiData != null){
          ob["multiData"] = multiData;
          this.applyMultiTableData(multiData,ob);
        }
        
        ob["entityName"] = this.entityName;
        
        if (this.evento == "inserindo") {
          this.fs.removeIndentityFields(ob, this.tableInformation);
        }
      
        this.disabled = true;  
        this.sub = this.http.post(ob,"JsonBrokerServices/save",true).subscribe(
          data=> {
              
              if ( this.evento == "inserindo"){
                this.row = this.formGroup.getRawValue();
                this.snackBar.showSuccess("Registro incluído com sucesso.");
                if (multiData==null){
                  this.evento ='editando';
                  if ( this.$$REFERENCES == null || this.$$REFERENCES.length==0  ){
                    this.saving.emit({changing:true, keepOpen:false});
                  }else{
                    this.saving.emit({changing:true, keepOpen:true});
                  }
                }
                
              }else{
                this.snackBar.showSuccess("Registro alterado com sucesso.");
                this.row= this.formGroup.getRawValue();
                this.saving.emit({changing:true, keepOpen:true});
              }
              if ( multiData == null ){
                this.fs.refreshPk(this.formGroup,data);
                this.fs.refreshRowPk(this.row,data);
                this.loadReference();
              }

              this.formulaSevices.toMap({evento:this.evento},this.map);
              this.formulaSevices.toMap(this.formGroup,this.map);
              this.formulaSevices.toMap(this.row,this.map);

              this.expanded_form = false;
              this.loadCustomComponents();
              //this.loadCustomParameters();      
              this.cd.detectChanges();
              this.formLoading = false;
              resolve(true);
          },
          (error) => {
            this.formLoading = false;
            this.disabled = false;
            throw error;
          },
  
          ()=>{
          }
        )
      }else{
          this.formLoading = false;
          this.snackBar.showError(this.fs.getFormErrors(this.formGroup,this.tableInformation));
      }
    });    
  }

  expand(){
    this.expanded_form = true;    
    this.customtab.forEach((x) => {
      if (x.options != null && x.options.api != null) {
        x.options.api.resize();
      }
    });
  }

  retract(){
    this.expanded_form = false;  
    this.customtab.forEach((x) => {
      if (x.options != null && x.options.api != null) {
        x.options.api.resize();
      }
    });
  }


  return(){
      this.expanded_form = false;
      this.saving.emit({changing:false, keepOpen:false});
  }
  

  eventEdit(event) {
    if (
      (this.permission.canEdit && (this.evento == "editando" || this.evento == null)) ||
      this.evento == "inserindo"
    ) {
      if (event) {
        this.disabled = false;
      }
    }
  }

  saveTabSizeDiv(event){
    this.sizeLeft = event.sizes[0];
    this.sizeRight = event.sizes[1];
    this.tranformToUserConfig();
    this.saveUserConfig();
  }

  cancelEdit() {
    if (this.designMode) {
      this.tableInformation = this.oldInformation as columnsDef[];

      this.designMode = false;

      this.customtab.forEach((x) => {
        try{
          if ( x.options!= null ){
            x.options["resizable"].enabled = this.designMode;
            x.options["pushItems"] = this.designMode;
            x.options["swap"] = this.designMode;
            x.options["draggable"].enabled = this.designMode;
            x.options.api.resize();
          }
        }catch(Error){}
        
        
      });

      this.customtab.forEach((x) => {
        if ( x.options!=null ){
          if (x.options.api && x.options.api.optionsChanged) {
            x.options.api.optionsChanged();
            x.options.api.resize();
          }
        }
      });
    }

    if (this.editMode) {
      this.editMode = false;
    }
  }

  clickDesenho(event) {
    this.oldInformation = JSON.parse(JSON.stringify(this.tableInformation));
    this.designMode = true;
    
    this.customtab.forEach((x) => {
      try{
        x.options["resizable"].enabled = this.designMode;
        x.options["pushItems"] = this.designMode;
        x.options["swap"] = this.designMode;
        x.options["draggable"].enabled = this.designMode;
        x.options.api.resize();
      }catch(Exception){}
      
    });

    this.customtab.forEach((x) => {
      try{
        if (x.options.api && x.options.api.optionsChanged) {
          x.options.api.optionsChanged();
          x.options.api.resize();
        }
      }catch(Excetion){}
      
    });
  }

  saveInfo() {
    
    if (this.designMode) {
      this.customtab.forEach((x) => {
        try{
          this.designMode = false;
          x.options["resizable"].enabled = this.designMode;
          x.options["pushItems"] = this.designMode;
          x.options["swap"] = this.designMode;
          x.options["draggable"].enabled = this.designMode;

          if (x.options.api && x.options.api.optionsChanged) {
            x.options.api.optionsChanged();
            x.options.api.resize();
          }
        }catch(Exception){}
        
      });
      this.designMode = false;
    }

    if (this.editMode) {
      this.savingLayout.next(true);
      this.editMode = false;
      this.expanded_form = false;
    }
    
    this.tranformToUserConfig();
    this.saveUserConfig();
  }

  click(event) {
    this.editMode = true;
  }

  ngAfterViewInit() {
    
    setTimeout(() => {
      this.customtab.forEach((x) => {
        if (x.options != null && x.options.api != null) {
          x.options.api.resize();
        }
      });
    });

    setTimeout(()=>{
      if (this.customFunction != null) {
        this.customFunction.call(this, this.formGroup,this.customFields,'init');
      }
    });
    
    
  }

  getCondition(): string | null {
    let ob: Object = {};

    this.tableInformation
      .filter((x) => {
        return x.ISPK === 1;
      })
      .forEach((y) => {
        ob['this.'+y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value;//jdbc
        //ob[y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value;
      });

    return ObjectUtil.transformConditionToString(ob);
  }

  ngOnInit() {
    
    this.mode = this.userConfig['mode'] == null ? 'classic' : this.userConfig['mode'] ;
    this.tabs = this.userConfig['tabs'] == null ? this.tabs :this.userConfig['tabs'];
    this.nodata = this.userConfig['nodata'] == null ? false :this.userConfig['nodata'];
    this.floatMenu = this.userConfig['floatMenu'] == null ? false :this.userConfig['floatMenu'];
    this.openPopup = this.userConfig['openPopup'] == null ? false :this.userConfig['openPopup'];
    this.sizeLeft = this.userConfig['sizeLeft'] == null ? 50: this.userConfig['sizeLeft'];
    this.sizeRight = this.userConfig['sizeRight'] == null ? 50: this.userConfig['sizeRight'];
    this.permission =  this.ap.checkPermission(this.entityName);
    
    if ( this.openPopup ){
      setTimeout(()=>this.expanded_form = true);
    }

    if (Object.keys(this.row).length == 0) {
      this.fs.refreshForm(
        this.formGroup,
        this.tableInformation,
        this.row,
        true
      );
      
      

      this.tableInformation
        .filter((x) => {
          return x.ISFK === 1 && x.ISPK === 1;
        })
        .forEach((y) => {
          if (ObjectUtil.isNotEmpty(this.parentRow)) {
            if (y.REFERENCES.length > 0) {
              let refConfig = this.tableInformation.find((data) => {
                return (
                  data.COLUMNNAME.indexOf("->") > -1 &&
                  JSON.parse(data.VALIDATIONERROR)["ColumnName"] == y.COLUMNNAME
                );
              });
              y.REFERENCES.forEach((data) => {
                this.formGroup
                  .get(y.COLUMNNAME)
                  .setValue(this.parentRow.linha[data.CONSTRAINT_COLUMN_REF]);
                let founded = false;

                Object.keys(this.parentRow.linha).forEach((d) => {
                  
                  if (d.split("->")[0] == data.CONSTRAINT_NAME) {
                  
                    if (refConfig != null) {
                      let index = this.parentRow.table_information.findIndex(
                        (k) =>
                          k.COLUMNNAME.indexOf("->") > -1 &&
                          JSON.parse(k.VALIDATIONERROR)["ColumnName"] ==
                            y.COLUMNNAME &&
                          k.COLUMNNAME == d
                      );
                      if (index > -1) {
                        founded = true;
                        
                        this.formGroup
                          .get(refConfig.COLUMNNAME)
                          .setValue(this.parentRow.linha[d]);
                      }
                    }
                  }
                });

                if (!founded) {
                  if (refConfig != null) {
                    Object.keys(this.parentRow.linha).forEach((d) => {
                      if (
                        refConfig.COLUMNNAME.split("->")[1] == d &&
                        JSON.parse(refConfig.VALIDATIONERROR)["RefName"] ==
                          this.parentRow.entityName
                      ) {
                        
                        founded = true;
                        this.formGroup
                          .get(refConfig.COLUMNNAME)
                          .setValue(this.parentRow.linha[d]);
                      }
                    });
                  }
                }
              });
            }
          }
        });
    } else {
      this.fs.refreshForm(
        this.formGroup,
        this.tableInformation,
        this.row,
        false
      );
    }

    if (this.evento == "editando" ) {
      //this.parentRow = this.row; //revisar esse trecho em 14/06/22 nao parece ter validade pois os tipos sao diferentes
      this.loadReference();
    }
    
    this.tableInformation.forEach((columnDef) => {
      let tabName = "Geral";
      if (ObjectUtil.isNotEmpty(columnDef.tab)) {
        tabName = columnDef.tab;
      }
  

      if (columnDef.visible) {
        this.visibleColumns.push({
          tabName: tabName,
          columnName: columnDef.COLUMNNAME,
          columnDesc: columnDef.COLUMNDESC,
          visible: true,
          checked: false,
        });
      } else {
        if (columnDef.COLUMNNAME.indexOf("->") == -1) {
          if ( (columnDef.NOSHOW == undefined || columnDef.NOSHOW == null || !columnDef.NOSHOW)  && !columnDef.visible ){
            this.nonVisibleColumns.push({
              tabName: "Disponivel",
              columnName: columnDef.COLUMNNAME,
              columnDesc: columnDef.COLUMNDESC,
              visible: false,
              checked: false,
            });
          }
        }
      }
      
      if (ObjectUtil.isNotEmpty(columnDef.tab)) {
        if (
          this.customtab.findIndex((value) => value.desctab == columnDef.tab) ==
          -1
        ) {
          
          if (columnDef.tab != undefined && columnDef.tab != "Disponivel") {
            let options = new GridsterOption().get();
            options.compactType = "compactUp";
            options.gridType = "verticalFixed";
            options.fixedRowHeight = this.gridsterHeigthRow;
            options.outerMarginRight=5;
            options.setGridSize = true;
            this.customtab.push({
              desctab: columnDef.tab,
              editing: false,
              options: options,
              active: true,
              originalName: columnDef.tab
            });
          }
        }
      }

      this.getConditionReference(columnDef);

      if ( this.tabs!=null && this.tabs.length > 0 ){
        this.tabs.forEach(t=>{
            let index = this.customtab.findIndex(d=>d.desctab==t.customName);
            let indexChild = this.children.findIndex(d=>d.entityName==t.entityName);
            if ( index == -1 && indexChild == -1){
              let options = new GridsterOption().get();
              options.compactType = "compactUp";
              options.gridType = "verticalFixed";
              options.fixedRowHeight = this.gridsterHeigthRow;
              options.outerMarginRight=5;
              options.setGridSize = true;
              
              this.customtab.push({
                desctab: t.customName,
                editing: false,
                options: options,
                active: true,
                isFk: false,
                originalName: t.originalName
              });
            }
        })
      }

    });

    
    if (
      "S" == this.forceParentRow &&
      this.parentRow != null &&
      this.parentRow.linha != null &&
      Object.keys(this.row).length == 0
    ) {
      Object.keys(this.parentRow.linha).forEach((columnName) => {
        try {
          
          this.formGroup
            .get(columnName)
            .setValue(this.parentRow.linha[columnName]);
        } catch (Exception) {}
      });
    }
    
    
    

    this.map = new Map<string,any>();
    this.formulaSevices.toMap({evento:this.evento},this.map);
    this.formulaSevices.toMap(this.formGroup,this.map);
    this.formulaSevices.toMap(this.row,this.map);

    this.loadTabs();
    this.loadMultiTable();
    this.loadCustomComponents();
    
    
  }

  loadMultiTable(){
    if ( this.dataMultiTableConfig != null && this.dataMultiTableConfig.length>0 ){
      
      let active = false;
      if ( this.evento =='inserindo'){
        active=true;
        this.showMulti = true;
      }
      let index = this.tabs.findIndex(t=>t.entityName == 'multitable');
      
      
      if( index == -1){
        this.tabs.push({
          active: active,
          dynamic: true,
          customName: 'Busca Multipla',
          originalName:'mutitable',
          entityName:'multitable'
        });
      }else{
          this.tabs[index].active=active;
      }
      
    }     
  }


  loadCustomComponents(){
      
      this.customComponents.forEach(d=>{
        let index = this.tabs.findIndex(t=>t.entityName ==  d['componentName']);
        if( index>-1){
          this.tabs.splice(index,1);
        }

        
        if ( d['onChangeFields']!=null ){
          
          let fields:String[]= d['onChangeFields'].split('\,');
          for ( var field of fields){
            try{
              
              this.sub1 = this.formGroup.get(field.toUpperCase()).valueChanges.subscribe(ob=>{
                  this.formulaSevices.toMap({evento:this.evento},this.map);
                  this.formulaSevices.toMap(this.formGroup,this.map);
                  this.formulaSevices.toMap(this.row,this.map);

                  this.showCustomComponents(d);
                  
              })
            }catch(Exception){}
              
          }
        }
        
        this.showCustomComponents(d);
        
      });
      
      this.loadCustomParameters();
  }

  showCustomComponents(d:Object){
    
    let tabIndex =  this.tabs.findIndex(t=>t.entityName ==  d['componentName']);

        if ( tabIndex == -1){
          
          let canShow = d['activationFormula']!= null ? this.formulaSevices.calculate(d['activationFormula'],this.map):true;

          if ( canShow ){
            this.tabs.push({
              customName:d['componentDesc'],
              originalName:d['componentName'],
              entityName:d['componentName'],
              active:canShow,
              dynamic: true
            });
          }
        }else{
          let canShow = d['activationFormula']!= null ? this.formulaSevices.calculate(d['activationFormula'],this.map):true;
          this.tabs[tabIndex].active = canShow;
        }
  }

  loadCustomParameters(){
    this.customComponentdata = {
      evento: this.evento,
      row: this.row,
      formGroup: this.formGroup,
      parentRow: {
        linha: this.row,
        table_information: this.tableInformation,
        entityName: this.entityName,
      },
      actionList: this.actionList,
      forceParentRow: this.forceParentRow,
      $$REFERENCES: this.$$REFERENCES,
      formViewColumns: this.formViewColumns,
      entityName: this.entityName,
      filter: this.filter,
      userConfig: this.userConfig,
      tableInformation: this.tableInformation,
      canConfig: this.canConfig,
      condition: this.getCondition()
    };
  }

  loadTabs(){
    if ( this.tabs==null || this.tabs.length==0){
      this.tabs = [...this.customtab.map(d=>({customName:d.desctab, originalName: d.originalName, active:true, dynamic: false })),...this.children.map(d=>({customName: d.entityDesc, originalName: d.entityDesc, entityName:d.entityName, active:true, dynamic: false}))];
    }else{
      this.children.forEach(d=>{
        let expressao = d.expression;
        let active:boolean = true;
        if ( this.tabs.findIndex(t=>t.entityName ==  d.entityName) == -1){
            if ( expressao != null){
              active = this.formulaSevices.calculate(expressao,this.map);
            }
            this.tabs.push({customName: d.entityDesc, originalName: d.entityDesc, entityName:d.entityName, active:active, dynamic: false}) ;
        }else{
            // Tratando trecho que nao estava atualizando o nome da aba   
            let index = this.tabs.findIndex(t=>t.entityName ==  d.entityName);
            this.tabs[index].customName = d.entityDesc;
            this.tabs[index].originalName = d.entityDesc;
            

            if ( expressao != null ){
              active = this.formulaSevices.calculate(expressao,this.map);
            }
            
        }
      }); 
    }

    Array.from(new Set(this.customFields.map(d=>d!=null && d.tab))).forEach(tab=>{
        if ( this.tabs.findIndex(d=>d.originalName == tab) == -1){
          this.tabs.push({customName:tab, originalName: tab, active:true, dynamic: false });    
        }
    });
        
    

    let i = 0;
    for (var tab of this.tabs){
      if ( typeof(tab)=='string'){
          let strTab:string = tab;

          let tabData:tab = {
              active:true,
              customName:strTab,
              dynamic:false,
              originalName:strTab,
              entityName:strTab
          }
          this.tabs[i] = tabData;
      }else{
        if ( Object.keys(tab).findIndex(d=>d=='active')==-1 ){
          tab.active = true;
        }
        if ( Object.keys(tab).findIndex(d=>d=='dynamic')==-1 ){
          tab.dynamic = false;
        }
      }
      i++;
    }

    this.stepData = [];

    if ( this.mode == 'step'){
      this.tabs.filter(x=>x.active).forEach(d=>{
          this.stepData.push({
              buttonList:[],
              name:d.originalName,
              sideDesc: d.customName,
              title: d.customName
          });
      });
    }

  }

  getChildEntity(item:tab){
    return this.children.find(d=>d.entityName==item.entityName);
  }

  getTab(item:tab){
    return this.customtab.find(d=>d.desctab==item.customName);
  }

  getCustomTab(item:tab){
    return this.customtab.findIndex(d=>d.desctab==item.customName && (d.isFk == null || d.isFk == false ) ) > -1 
      && this.children.findIndex(d=>d.entityDesc==item.customName) == -1
      && this.customComponents.findIndex(d=>d['componentName']==item.entityName) == -1
      && item.entityName!='multitable'
    //? false : true;
  }

  getChildrenTab(item:tab){
    return this.children.findIndex(d=>d.entityName==item.entityName) == -1 ? false : true;
  }

  getCustomComponent(item:tab){
    return this.customComponents.findIndex(d=>d['componentName']==item.entityName) == -1 ? false : true;
  }


  getCustomComponentReg(item:tab){
      return REGISTRY.get(item.entityName);
  }

  loadReference() {
    if ("S" == this.removeReference) {
      return;
    }
    
    if (ObjectUtil.isNotEmpty(this.$$REFERENCES)) {
      
      this.$$REFERENCES.forEach((obj) => {
        this.hasChild = true;
        let child: ChildrenForm = {
          entityName: this.capitalize.transform(obj["entityName"]),
          entityDesc: obj["entityDesc"],
          constraintName: obj["constraintName"],
          columns: obj["columns"],
          condition: this.getCondition(),
          parentRow: {
            linha: this.row,
            table_information: this.tableInformation,
            entityName: this.entityName,
          },
        };
        let childIndex = this.children.findIndex(
          (x) => x.entityName == obj["entityName"]
        );
        if (childIndex == -1) {
          this.children.push(child);
        } else {
          this.children[childIndex] = child;
        }
      });
      
      this.loadTabs();
    }
  }

  onChanging(event) {
    this.visibleColumns.forEach((visible) => {
      let columnsDef: columnsDef = this.tableInformation.find(
        (col) => col.COLUMNNAME == visible.columnName
      );
      columnsDef.visible = true;
      columnsDef.tab = visible.tabName;

      let maxY = Math.max(
        ...this.tableInformation
          .filter((d) => {
            return d.tab == visible.tabName;
          })
          .map((x) => x.y)
      );

      if (maxY == null) {
        maxY = 0;
      }

      if (columnsDef.x < 0 || columnsDef.x == null) {
        columnsDef.x = 0;
      }
      if (columnsDef.y < 0 || columnsDef.y == null) {
        columnsDef.y = maxY + 1;
      }
    });

    this.nonVisibleColumns.forEach((nonVisible) => {
      if (!nonVisible.visible) {
        let columnsDef = this.tableInformation.find(
          (col) => col.COLUMNNAME == nonVisible.columnName
        );
        columnsDef.x = -1;
        columnsDef.y = -1;
        columnsDef.visible = false;
        columnsDef.tab = nonVisible.tabName;
      }
    });

    this.cd.detectChanges();
    
  }

  configureVisibility() {}

  calculateTabInde(col: columnsDef) {
    if (col.y != null && col.x != null) {
      return Number("10" + col.y.toString() + col.x.toString());
    } else {
      return -1;
    }
  }

  saveUserConfig() {
    let jsonDec: Object = {
      entityName: "Mktpdic",
      condition: `instancename='${this.entityName}'`,
    };
    
    this.userConfig["config"] = this.formView;
    this.userConfig["mode"] = this.mode;
    this.userConfig["tabs"] = this.tabs;
    this.userConfig["nodata"] = this.nodata;
    this.userConfig["floatMenu"] = this.floatMenu;
    this.userConfig["sizeRight"] = this.sizeRight;
    this.userConfig["sizeLeft"] = this.sizeLeft;
    
    // Object.keys(this.userConfig).forEach(key=>{
    //   if ( key != 'formViewColumns' && key !='config' && key !='configgrid'){
    //     userConfig[key] = this.userConfig[key];
    //   }
    // })

    this.ucs
      .saveUserCfg(jsonDec, this.uas.user.iduser, this.filter, this.userConfig)
      .then(
        (me) => {
          this.snackBar.showSuccess("Configurações gravadas com sucesso.");
          this.fs.refreshForm(
            this.formGroup,
            this.tableInformation,
            this.row,
            true
          );
        },
        (error) => {
          this.snackBar.showError(error);
        }
      );
  }

  

  callCustomAction(action: action) {
    if (action.TYPE === "P" || action.TYPE === "J" || action.TYPE==="F") {
      if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
        this.dialogServices.openGenericDialog(
          CustomActionParametersComponent,
          action.PARAMETERS,
          (data) => {
            this.executeCustomAction(action, data);
          }
        );
      } else {
        this.executeCustomAction(action, null);
      }
    } else {
      if (action.TYPE == "A") {
        let serviceName = action.EXPRESSION.split(".")[0];
        let methodName = action.EXPRESSION.split(".")[1];
        let parameter = action.PARAMETERS;
        const component = REGISTRY.get(serviceName);
        const service = this.injector.get<any>(component);
        const method = service[methodName];
        const paramCount = method.length;

        if ( parameter != null && parameter.length > 0) {
          if (paramCount == 2 ){
            service[methodName]([this.formGroup.getRawValue()],parameter);
          }else if ( paramCount ==3 ) {
            service[methodName]([this.formGroup.getRawValue()],parameter, this);
          }else if ( paramCount ==1 ){
            service[methodName]([this.formGroup.getRawValue()]);
          }else{
            service[methodName]();
          }
        }else{
          if (paramCount == 1 ){
            service[methodName]([this.formGroup.getRawValue()]);
          }else if ( paramCount ==2 ) {
            service[methodName]([this.formGroup.getRawValue()], this);
          }else{
            service[methodName]();
          }
        }
        
        
      }else if(action.TYPE == "C"){
        if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
          this.dialogServices.openGenericDialog(
            CustomActionParametersComponent,
            action.PARAMETERS,
            (data) => {
              //this.executeCustomAction(action, data);
              openFlowData(data,this);
            }
         );
        }else{
          openFlowData(null, this);

        }        
      }
    }

    function openFlowData(parameters, self) {
      let flowData: flowData = {
        selected: self.row,
        function: null,
        action: action,
        parameters: parameters
      };

      self.dialogServices.openGenericDialog(
        FlowModalComponent,
        flowData,
        (data) => {
        }
      );
    }
  }

  executeCustomAction(
    action: action,
    parameters: string,
    retry: boolean = false
  ) {
    this.http
      .executeBackEndAction(
        this.entityName,
        action,
        [this.formGroup.getRawValue()],
        parameters,
        retry
      )
      .subscribe(
        (sucesso) => {
          let mensagens: string[] = sucesso["mensagens"];

          let mensagemFinal: string = "";
          if (ObjectUtil.isNotEmpty(mensagens)) {
            mensagens.forEach((mensagem) => {
              mensagemFinal = mensagemFinal + mensagem + "\n\r";
            });

            this.snackBar.showSuccess(mensagemFinal);
          } else {
            this.snackBar.showSuccess("Ação executada com sucesso.");
          }

          this.refresh();
        },
        (exception) => {
          if (exception instanceof HttpErrorResponse) {
            if (
              ObjectUtil.isNotEmpty(exception.error) &&
              ObjectUtil.isNotEmpty(exception.error.message)
            ) {
              if (
                (exception.error.message as String).indexOf(
                  "__CHOOSE__N__S__"
                ) > -1
              ) {
                let title = exception.error.message.split("__")[2];
                this.dialogServices.openNewDialog(
                  title,
                  (data) => {
                    this.executeCustomAction(action, parameters, true);
                  },
                  (data) => {
                    this.snackBar.showInformation(
                      "Processo cancelado pelo usuário."
                    );
                  }
                );
              } else {
                throw exception;
              }
            } else {
              throw exception;
            }
          } else {
            throw exception;
          }
        }
      );
  }

  getConditionReference(col:columnsDef){
    
    let values:reference[] = col.REFERENCES;
    let expression = '';
    let data = '';
    
    if (values){
        for ( let value of  values){
          
          expression = value.EXPRESSION;
          
          if ( expression ){
            let regex = new RegExp(/{@(.*?)}/g);
            var match;
            data = expression;
            while ((match = regex.exec(expression)) !== null) {
            
                let variable:string = match[0];
                
                let workVariable:string = variable.toUpperCase();
                if (workVariable.indexOf('@PARENT') > -1  ){

                  if ( this.parentRow.linha ){
                    workVariable = workVariable.replace("{@", "").replace("}", "");
                    let splited = workVariable.split('\.',)[1];
                    if( this.parentRow.linha[splited]){
                      let toReplace = this.parentRow.linha[splited];
                      data = data.replace(variable,toReplace);
                    }
                  }
                }else{
                  let workVariable = variable.replace("{@", "").replace("}", "").toUpperCase();
                  if ( this.row[workVariable] ){
                    let toReplace = this.row[workVariable];
                    data = data.replace(variable,toReplace);
                  }
                }
            }
          }
          col.REFEXPRESSION = data;
        }
        
      }      
  }

  copyConfiguration(){
      this.dialogServices.openGenericDialog(CopyFormConfigurationComponent,{entityName:this.entityName, userConfig:this.userConfig, filter: this.filter},(retorno)=>{
          this.snackBar.showSuccess("Configurações copiadas com sucesso.");
      },()=>{
          this.snackBar.showInformation("Processo cancelado.")
      })
  }
  


  checkStep(tipo){
    const count = this.activeStepsCount();

    if ( count === 0 ){
      return true;
    }

    if ( tipo =='B'){
      if ( this.wizardStep === 0){
          return true;
      }
    }

    if ( tipo == 'A'){
      if ( this.wizardStep === count - 1){
          return true;
      }
    }

    return false;


  }

  restoreConfiguration(){

      this.formLoading = true;
      let ob = {
      "entityName":"Mktpcontractpref",
      "sql":`SELECT  C.IDUSER,C.USERNAME
            FROM MKTPCONTRACTPREF A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
                                    INNER JOIN MKTPUSER C ON CONVERT(VARCHAR(500),A.TEXT)=C.USERNAME
            WHERE (A.CODECONTRACT IN (${this.uas.getContracts()}) 
            OR A.CODECOMPANY IN (${this.uas.getCompanies()}))
            AND A.NAME= 'mktp.user.modelo'
            AND C.ACTIVE='S'
            ORDER BY 1`
      }
     
      this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
          next:  (data)=>{
            if ( data['SQL'] as Object[]){
              if ( (data['SQL'] as Object[]).length > 1){
                throw Error('Impossível determinar usuário modelo. Verificar configurações.');
              }else{
                if ((data['SQL'] as Object[]).length == 0 ){
                   throw Error('Não existe usuário modelo vinculado ao seu usuário.');
                }else{
                  let idUserModel = (data['SQL'] as Object[])[0]['IDUSER'];
                  this.copyConfigurationModel(idUserModel);
                }
              }
            }
            this.formLoading = false;
        },
        error: (error)=>{
            this.formLoading = false;
            throw error;
        }
    });
  }

  copyConfigurationModel(idUserOrig){

    this.dialogServices.openNewDialog("Deseja subsituir as informações pelo modelo?",()=>{
      this.formLoading = true;
      this.getEntity(idUserOrig).then(async (idInstanceTable:any[])=>{
        if ( idInstanceTable !=null ){
          for ( var idInstanceVar of idInstanceTable){
            let idInstance = idInstanceVar['IDINSTANCE'];
            let instanceName = idInstanceVar['INSTANCENAME'];
            let type = idInstanceVar['TYPE'];
            let dataConfig = null;
            if ( type=='PARENT'){
              dataConfig = this.userConfig;
            }else{
              dataConfig = JSON.parse(idInstanceVar['CONFIG']);
            }

            let dataFilter = null;
            if ( type=='PARENT'){
              dataFilter = this.filter;
            }else{
              dataFilter = JSON.parse(idInstanceVar['FILTER']);
            }
            
            
            await this.saveUser(idInstance,this.uas.user.iduser,this.uas.user.username, instanceName, dataConfig, dataFilter).then(msg=>{
              this.snackBar.showSuccess(msg.toString())
            }).catch(error=>{
              this.formLoading = false;
              throw error;
            }).finally(()=>{
            })
        
          } 
          this.formLoading = false;
        }else{
          this.formLoading = false;
          throw Error('Não foi possível determinar instância.');
        }   
      });
    },()=>{
        this.formLoading = false;
        this.snackBar.showInformation("Processo cancelado pelo usuário.");
    })
  }

  async getEntity(idUser){
    return await new Promise((resolve, reject) => {
  
      let queryBuscaAcoes = {
        entityName: "Mktpdic",
        sql: `SELECT IDINSTANCE,INSTANCENAME, 'PARENT' TYPE, NULL CONFIG,NULL FILTER FROM MKTPDIC WHERE INSTANCENAME='${this.entityName}'
        UNION ALL
        SELECT X.IDINSTANCE, X.INSTANCENAME, 'CHILD' TYPE, CFG.CONFIG, CFG.FILTER
        
        FROM MKTPDIC  X INNER JOIN MKTPUSERCFG CFG ON CFG.IDINSTANCE=X.IDINSTANCE AND CFG.IDUSER= ${idUser}
        WHERE X.IDINSTANCE IN (SELECT DISTINCT IDINSTANCE FROM GETFULLREFERENCE('${this.entityName}',100))
        AND X.INSTANCENAME!='${this.entityName}'`
      };

      this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
            let idInstance = con["SQL"] as Object[];
            resolve(idInstance);
          });
      });
  }

  async saveUser(idInstance,idUser,name,instanceName,dataConfig,dataFilter){
    return await new Promise((resolve, reject) => {
      let jsonSave: Object = {
        entityName: "Mktpusercfg",
        IDINSTANCE: idInstance,
        IDUSER: idUser
      };

      jsonSave['FILTER'] =  JSON.stringify(dataFilter);
   
      jsonSave['CONFIG'] =  JSON.stringify(dataConfig);
      
      this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe( d=>{
          //this.snackBar.showSuccess(`Copia realizada com sucesso para o usuário ${name} para a instância ${instanceName}`)
          resolve(`Copia realizada com sucesso para o usuário ${name} para a instância ${instanceName}`);
      });
    });
  }

  buscarDadosMultiTable(){

    let arrayData:Object[] = [];
    this.multiTableLoading = true;
    Object.keys(this.formGroup.controls).forEach(control=>{
      const abstractControl = this.formGroup.controls[control];
      
      if ( abstractControl.value != null){
        arrayData.push({
          'key':'@'+control.toUpperCase(),
          'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
        })
      }
    })

    let ob = {
        'expressao': '{@getMultiTable_'+this.entityName.toUpperCase()+'}',
        'novo':true,
        'codecontract':this.row["CODECONTRACT"] == null ? Number(this.formGroup.get("CODECONTRACT").value): this.row["CODECONTRACT"],//this.uid.user.codecompany,
        'codecompany': this.row["CODECOMPANY"] == null ? Number(this.formGroup.get("CODECOMPANY").value): this.row["CODECOMPANY"],//this.uid.user.codecompany,
        'codemktp':0,
        'values':arrayData
    } 

    this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(data=>{
      let resultado = data['resultado'];
      let objeto  = JSON.parse(resultado);
      let SQL:Object[] = objeto['SQL'];
      
      if ( SQL ){
          this.dataMultiTable = SQL;
      }else{
        this.dataMultiTable =[];
      } 
  
      this.multiTableLoading = false;
      this.cd.markForCheck();
    },error=>{
      this.multiTableLoading = false;
      throw error;
    },()=>{
      this.multiTableLoading = false;
    });
  }

  drag(event: any) {
    
    const value = event.target.dataset.value;
    let item = event.target.dataset.dragData;
    event.dataTransfer.setData('text/plain', item);
  }


  applyMultiTableData(multiData: Object, data:Object|Object[]) {

    if ( data instanceof Array){
      let newData = JSON.parse(JSON.stringify(data));
      newData.forEach(linha=>{
        Object.keys(linha).forEach(field=>{
          let value = linha[field];
          if ( value!= null && typeof(value)=='string' ){
            let reg: RegExpMatchArray = value.match(/{@MULTI_(.*?)}/g);
            
            if (reg != null) {

                reg.forEach(d=>{
                  let fieldName = d.replace("{@MULTI_", "").replace("}", "");
                  let newValue = multiData[fieldName];
                  linha[field] = linha[field].replace(d,newValue)
                })
            }
          }
        })
      })
      return newData;
    }else{
      
      Object.keys(data).forEach(field=>{
          let value = data[field];
          
          if ( value!= null && typeof(value)=='string' ){
            
            let reg: RegExpMatchArray = value.match(/{@MULTI_(.*?)}/g);
            if (reg != null) {
              reg.forEach(d=>{
                let fieldName = d.replace("{@MULTI_", "").replace("}", "");
                let newValue = multiData[fieldName];
                data[field] = data[field].replace(d,newValue)
              })
                
            }
          }
      })
      return data;
    }
    
  }
}
